<template>
    <Transition
        enter-active-class="duration-500 ease-out"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="duration-250 ease-in"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div v-show="!hasBeenSeen" class="controls--explanation not--responsive" v-click-away="handleCloseControls">
            <div class="header--control">
                <h2>Contrôles</h2>
                <button type="button" @click.prevent="handleCloseControls">
                    <svg  class="close--controls" xmlns="http://www.w3.org/2000/svg" width="21.69" height="20.724" viewBox="0 0 21.69 20.724">
                        <g id="Groupe_9" data-name="Groupe 9" transform="translate(-258.959 -31.138)">
                            <line id="Ligne_1" data-name="Ligne 1" x2="21" y2="20" transform="translate(259.304 31.5)" fill="none" stroke="#fff" stroke-width="1"/>
                            <line id="Ligne_3" data-name="Ligne 3" y1="20" x2="21" transform="translate(259.304 31.5)" fill="none" stroke="#fff" stroke-width="1"/>
                        </g>
                    </svg>
                </button>
            </div>
            <div class="controls--picto">
                <div class="picto--1 picto">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13.97" height="21.132" viewBox="0 0 13.97 21.132">
                        <g id="Groupe_117" data-name="Groupe 117" transform="translate(0.75 0.75)">
                            <g id="Groupe_24" data-name="Groupe 24">
                                <path id="Tracé_18" data-name="Tracé 18" d="M6.985,40.419A6.993,6.993,0,0,1,0,33.434V26.272a6.985,6.985,0,1,1,13.97,0v7.162A6.993,6.993,0,0,1,6.985,40.419Zm0-19.632A5.491,5.491,0,0,0,1.5,26.272v7.162a5.485,5.485,0,1,0,10.97,0V26.272A5.491,5.491,0,0,0,6.985,20.787Z" transform="translate(-0.75 -20.037)" fill="#a2a2a2"/>
                            </g>
                            <path id="Ligne_9" data-name="Ligne 9" d="M0,6.659a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V5.909A.75.75,0,0,1,0,6.659Z" transform="translate(6.235 3.908)" fill="#fe0982"/>
                        </g>
                    </svg>
                    <span>Zoom</span>
                </div>
                <div class="picto--2 picto">
                    <svg xmlns="http://www.w3.org/2000/svg" width="36.017" height="21.13" viewBox="0 0 36.017 21.13">
                        <g id="Groupe_117" data-name="Groupe 117" transform="translate(-60.72 -21.988)">
                            <path id="Tracé_19" data-name="Tracé 19" d="M39.242,19.291a6.974,6.974,0,0,1,4.938,2.037l0,0a6.974,6.974,0,0,1,2.037,4.938v7.16a6.985,6.985,0,1,1-13.97,0v-7.16A6.993,6.993,0,0,1,39.242,19.291Zm3.88,3.1a5.494,5.494,0,0,0-9.37,3.88v7.16a5.485,5.485,0,1,0,10.97,0v-7.16A5.483,5.483,0,0,0,43.122,22.391Z" transform="translate(28.468 2.697)" fill="#a2a2a2"/>
                            <path id="Tracé_21" data-name="Tracé 21" d="M39.242,20.041v8.6H33V26.271A6.239,6.239,0,0,1,39.242,20.041Z" transform="translate(28.468 2.697)" fill="#fe0982"/>
                            <path id="Tracé_21_-_Contour" data-name="Tracé 21 - Contour" d="M39.242,19.291a.75.75,0,0,1,.75.75v8.6a.75.75,0,0,1-.75.75H33a.75.75,0,0,1-.75-.75V26.271A6.993,6.993,0,0,1,39.242,19.291Zm-.75,8.6V20.842a5.492,5.492,0,0,0-4.74,5.429V27.9Z" transform="translate(28.468 2.697)" fill="#fe0982"/>
                            <path id="Ligne_10" data-name="Ligne 10" d="M.75,11.829H-.75V0H.75Z" transform="translate(89.958 26.53)" fill="#fe0982"/>
                            <path id="Tracé_25" data-name="Tracé 25" d="M41.173,3.741,39.242,1.811,37.312,3.741,36.251,2.681,38.712.22a.75.75,0,0,1,1.061,0l2.461,2.461Z" transform="translate(50.721 25.78)" fill="#fe0982"/>
                            <path id="Tracé_26" data-name="Tracé 26" d="M39.242,13.547a.75.75,0,0,1-.53-.22l-2.461-2.461,1.061-1.061,1.931,1.931,1.931-1.931,1.061,1.061-2.461,2.461A.75.75,0,0,1,39.242,13.547Z" transform="translate(50.721 25.78)" fill="#fe0982"/>
                            <path id="Ligne_11" data-name="Ligne 11" d="M11.829.75H0V-.75H11.829Z" transform="translate(84.158 32.548)" fill="#fe0982"/>
                            <path id="Tracé_27" data-name="Tracé 27" d="M43.335,9.765,42.274,8.7,44.2,6.774,42.274,4.843l1.061-1.061L45.8,6.243a.75.75,0,0,1,0,1.061Z" transform="translate(50.721 25.78)" fill="#fe0982"/>
                            <path id="Tracé_28" data-name="Tracé 28" d="M35.149,9.765,32.688,7.3a.75.75,0,0,1,0-1.061l2.461-2.461L36.21,4.843,34.279,6.773,36.21,8.7Z" transform="translate(50.721 25.78)" fill="#fe0982"/>
                        </g>
                    </svg>
                    <span>Rotation</span>
                </div>
                <div class="picto--3 picto">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13.97" height="21.13" viewBox="0 0 13.97 21.13">
                        <g id="Groupe_28" data-name="Groupe 28" transform="translate(0.75 0.75)">
                            <path id="Tracé_22" data-name="Tracé 22" d="M71.494,19.291a6.974,6.974,0,0,1,4.938,2.037l0,0a6.974,6.974,0,0,1,2.037,4.938v7.16a6.985,6.985,0,1,1-13.97,0v-7.16A6.993,6.993,0,0,1,71.494,19.291Zm3.88,3.1A5.494,5.494,0,0,0,66,26.271v7.16a5.485,5.485,0,1,0,10.97,0v-7.16A5.483,5.483,0,0,0,75.374,22.391Z" transform="translate(-65.254 -20.041)" fill="#a2a2a2"/>
                            <path id="Tracé_24" data-name="Tracé 24" d="M71.494,20.041v8.6h-6.24V26.271A6.239,6.239,0,0,1,71.494,20.041Z" transform="translate(-65.254 -20.041)" fill="#fe0982"/>
                            <path id="Tracé_24_-_Contour" data-name="Tracé 24 - Contour" d="M71.494,19.291a.75.75,0,0,1,.75.75v8.6a.75.75,0,0,1-.75.75h-6.24a.75.75,0,0,1-.75-.75V26.271A6.993,6.993,0,0,1,71.494,19.291Zm-.75,8.6V20.842A5.492,5.492,0,0,0,66,26.271V27.9Z" transform="translate(-65.254 -20.041)" fill="#fe0982"/>
                        </g>
                    </svg>
                    <span>Click</span>
                </div>
            </div>
        </div>
    </Transition>

    <Transition
        enter-active-class="duration-500 ease-out"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="duration-500 ease-in"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
    >

        <div v-show="!hasBeenSeen" class="controls--explanation responsive" v-click-away="handleCloseControls" >
            <div class="controls--picto">
                <button type="button" @click.prevent="handleCloseControls">
                    <svg @click="handleCloseControls" class="close--controls" xmlns="http://www.w3.org/2000/svg" width="21.69" height="20.724" viewBox="0 0 21.69 20.724">
                        <g id="Groupe_9" data-name="Groupe 9" transform="translate(-258.959 -31.138)">
                            <line id="Ligne_1" data-name="Ligne 1" x2="21" y2="20" transform="translate(259.304 31.5)" fill="none" stroke="#fff" stroke-width="1"/>
                            <line id="Ligne_3" data-name="Ligne 3" y1="20" x2="21" transform="translate(259.304 31.5)" fill="none" stroke="#fff" stroke-width="1"/>
                        </g>
                    </svg>
                </button>
                <div class="picto--1 picto">
                    <img :src="appUrl + '/img/controls/hand-pinch.svg'" alt="">
                    <span>Zoom</span>
                </div>
                <div class="picto--2 picto">
                    <img :src="appUrl + '/img/controls/hand-swipe.svg'" alt="">
                    <span>Rotation</span>
                </div>
                <div class="picto--3 picto">
                    <img :src="appUrl + '/img/controls/hand-click.svg'" alt="">
                    <span>Click</span>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script>
    import {directive} from "vue3-click-away";

    export default {
        emits: ['closeControls'],
        data() {
            return {
                appUrl: process.env.MIX_APP_URL
            }
        },
        props: {
            hasBeenSeen: Boolean,
        },
        methods: {
            handleCloseControls() {
                this.$emit('closeControls')
            }
        },
        directives: {
            ClickAway: directive
        }
    }
</script>
